import React from "react";
import { Redirect } from "react-router-dom";
import { useUser } from "../../contexts";
import { ChooseUploadType } from "../../interfaces";
import { hasDashboardPermission } from "../../utils";

const Home: React.FC = () => {
  const [{ user, order }] = useUser();

  return hasDashboardPermission(user) ? (
    <Redirect to="/dashboard" />
  ) : order.id === "not_found" ? (
    <Redirect to="/login" />
  ) : order.chooseUpload === ChooseUploadType.bulkUpload ? (
    <Redirect to="/account" />
  ) : (
    <Redirect to="/account" />
  );
};

export default Home;
